// @ts-strict-ignore
import * as React from 'react';

import {InputReact} from 'common/components/input';
import {ValidationStatus} from 'common/components/input/types';

import textInputStyleOverride from './text-input.inline.styl';

type Props = {
  placeholder?: string;
  validator?: (value: string) => boolean;
  defaultValue?: string;
  onBlur?: (value: string) => void;
  hideValidCheckMark?: boolean;
  onSelect?: any;
  style?: React.CSSProperties;
  autoFocus?: boolean;
  onChange?: (value: string) => void;
  extraCss?: string;
};

export const TextInput = React.forwardRef(
  (
    {
      placeholder,
      validator,
      defaultValue,
      onBlur,
      hideValidCheckMark,
      onSelect,
      style,
      autoFocus,
      onChange,
      extraCss,
    }: Props,
    ref,
  ) => {
    const [value, setValue] = React.useState(defaultValue ?? ``);
    const [validity, setValidity] = React.useState<ValidationStatus>(ValidationStatus.Default);

    const styleOverride = extraCss ? `${textInputStyleOverride}\n${extraCss}` : textInputStyleOverride;

    return (
      <div
        ref={ref as unknown as React.Ref<HTMLDivElement>}
        onKeyDown={(event) => {
          if (event.key === `Enter`) {
            onBlur(value);
          }
        }}
        style={{width: `100%`}}
      >
        <InputReact
          style={style}
          placeholder={placeholder}
          type='text'
          onInput={({target}) => {
            setValue(target.value);
            onChange && onChange(target.value);
          }}
          value={value}
          validationStatus={
            hideValidCheckMark && validity === ValidationStatus.Valid ? ValidationStatus.Default : validity
          }
          onSelect={onSelect}
          onBlur={() => {
            if (value.length === 0) {
              setValidity(ValidationStatus.Default);
            } else if (!validator || validator(value)) {
              setValidity(ValidationStatus.Valid);
              onBlur && onBlur(value);
            } else {
              setValidity(ValidationStatus.Invalid);
            }
          }}
          // @ts-ignore
          styleOverride={styleOverride}
          autoFocus={autoFocus}
        />
      </div>
    );
  },
);
